import { createFileRoute } from "@tanstack/react-router";
import AdminBackgroundsPage from "@/admin/pages/backgrounds";

export const Route = createFileRoute("/admin/backgrounds/")({
  component: AdminBackgroundsPage,
});
